import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  {
    num: "1",
    title: "Ideen melden",
    text: "Ein Prozess der automatisiert werden sollte? Ein internes Tool das fehlt? Eine Datenquelle die euch das Leben leichter macht? Her damit.",
  },
  {
    num: "2",
    title: "Probleme benennen",
    text: "Was nervt am meisten? Was kostet Zeit? Wo fehlen Informationen? Eure Erfahrung bestimmt was wir als Nächstes angehen.",
  },
  {
    num: "3",
    title: "Feedback geben",
    text: "Was funktioniert gut? Was nicht? Ehrliches Feedback hilft mehr als Höflichkeit.",
  },
];

export function Slide22Team(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Mitmachen</div>
        <h1 className="deck-title rise rise-2">
          So bringt ihr <br />
          <span className="accent">Themen ein</span>
        </h1>
      </header>

      <div className="team-body">
        <div className="deck-cols3">
          {TILES.map((t, i) => (
            <div key={t.num} className={`col-card rise rise-${i + 4}`}>
              <div className="col-eyebrow">{t.num}</div>
              <h4>{t.title}</h4>
              <p>{t.text}</p>
            </div>
          ))}
        </div>

        <div
          className="col-card rise rise-7"
          style={{ borderColor: "rgba(0,141,247,0.5)" }}
        >
          <div className="col-eyebrow" style={{ color: "var(--svo-blau)" }}>
            Wie?
          </div>
          <h4>
            Wir bauen gerade ein Tool, mit dem ihr das direkt einreichen könnt.
          </h4>
          <p>
            Bis dahin: E-Mail, Teams, Brieftaube <span aria-label="Taube" role="img">🕊️</span>
          </p>
        </div>
      </div>

      <footer className="deck-foot">
        <span>Kurze Wege, schnelle Umsetzung – egal ob Prozess, Tool oder Datenquelle.</span>
      </footer>
    </div>
  );
}
